import React from 'react';
import { connect } from 'react-redux';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'redux-form';
import { RadioField, TextField } from 'src/jbc-front/components/Form';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import { isThaiMoney } from 'src/utils/CustomValidators';
import { toBoolean } from 'src/utils/Number';
import styles from './UnionDuesContributionSection.scss';

const FIXED_AMOUNT_VALUE = 'fixed_amount';

const isUnionDuesFixedAmountType = value => value === FIXED_AMOUNT_VALUE;

const UnionDuesContributionSection = props => {
  const { t } = useTranslation();
  const { unionDuesTypes, isUnionDuesContributions, isUnionDuesContributionValue, unionDuesTypeValue } = props;

  const isUnionDuesContribution = toBoolean(isUnionDuesContributionValue);
  const isFixedAmount = isUnionDuesFixedAmountType(unionDuesTypeValue);

  return (
    <div className={styles.container}>
      <FormSection name="employeeSsoSetting">
        <RadioField
          label={t('features.Employees.components.SocialSecurityContribution.union_dues_contribution')}
          name="isUnionDuesContribution"
          options={isUnionDuesContributions}
        />
        {isUnionDuesContribution && (
          <React.Fragment>
            <RadioField label={t('features.Employees.components.SocialSecurityContribution.union_dues_type')} name="unionDuesType" options={unionDuesTypes} />
            {isFixedAmount && <TextField name="unionDuesAmount" validate={isThaiMoney} yen />}
          </React.Fragment>
        )}
      </FormSection>
    </div>
  );
};

const mapStateToProps = state => {
  const employeeSsoSetting = getEmployeeFormValues(state)?.employeeSsoSetting;

  return {
    isUnionDuesContributionValue: employeeSsoSetting?.isUnionDuesContribution,
    unionDuesTypeValue: employeeSsoSetting?.unionDuesType,
    unionDuesTypes: getSelectOptions(state, 'unionDuesTypes'),
    isUnionDuesContributions: getSelectOptions(state, 'isUnionDuesContribution')
  };
};

export default connect(mapStateToProps)(UnionDuesContributionSection);
